import React, { useContext, useState } from 'react'
import BrandsContext from '../../../contexts/BrandsContext'
import { useParams } from 'react-router-dom'
import Wizard from '../Wizard'
import { getEditBrandParams } from '../../../utils/payload-generator'
import { LoaderDialog } from 'functional-foundations'

type PropsType = {
    goToListPage(): unknown
}

/**
 *
 */
const Show = ({ goToListPage }: PropsType) => {
    const [loading, setLoading] = useState(false)
    const { brands, editBrand, setBrandNetworkError } = useContext(BrandsContext)

    let { id } = useParams()
    id = Number.parseInt(id)
    const item = brands.find((x) => x.csp_brand_id === id)

    const onSubmit = async (data) => {
        setLoading(true)
        try {
            const editParams = await getEditBrandParams(data, item)
            await editBrand(editParams)
            goToListPage?.()
        } catch (err) {
            setBrandNetworkError('Something went wrong')
            console.error(err)
        } finally {
            setLoading(false)
        }
    }

    if (!item) {
        return 'Not found'
    }

    return <div>
        <Wizard
            item={item}
            mode='edit'
            onSubmit={onSubmit}
            goToListPage={goToListPage}
            onClickCancel={goToListPage}
        />
        <LoaderDialog
            isOpen={loading}
            title={'Processing your payment...'}
            subtitle='Please wait!'
            data-testid='loader-dialog'
        />
    </div>
}

export default Show
